import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import {
  GITHUB_ACCOUNT_LINKED,
  GITHUB_ACCOUNT_LINKED_PREFIX,
} from '../../../Modules/CourseInstance/Constraints';
import { Redirect } from 'react-router-dom';

const GitHubRedirect: React.FunctionComponent<RouteComponentProps> = ({
  location,
}): React.ReactElement => {
  const { pathname } = location;
  const redirectUrl = pathname.replace(`${GITHUB_ACCOUNT_LINKED_PREFIX}/`, '');

  return <Redirect to={`${redirectUrl}${GITHUB_ACCOUNT_LINKED}`} />;
};

export default withRouter(GitHubRedirect);
